<!-- @author Shyam, @date 12-12-2024, @description Purge data popup component-->

<div class="mainContent" style="overflow: hidden; height: 70vh;">

  <!-- Title Section -->
  <div style="height: 7vh; padding-left: 2%;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour">Purge Activity</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <!-- Form Section for Group Name and Retention Period -->
  <div style="height: 10vh; padding-left: 2%; padding-right: 2%; ">
    <form novalidate [formGroup]="FormValid" style="width: 100%;">
      <div class="row" style="margin-top: 15px;">
        <!-- Group Name -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Group Name</mat-label>
            <mat-select (selectionChange)="onGroupSelect($event)" formControlName="groupName" [disabled]="FormValid.get('groupName')?.disabled">
              <mat-option *ngFor="let groupName of groupNames" [value]="groupName">
                {{ groupName }}
              </mat-option>
              
            </mat-select>
            <mat-error *ngIf="FormValid.get('groupName')?.invalid && (FormValid.get('groupName')?.dirty || FormValid.get('groupName')?.touched)">
              <span *ngIf="FormValid.get('groupName')?.hasError('required')">Group Name is required</span>
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Retention Period -->
        <div class="col-lg-3">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@TMSCHOOLFEESMASTERinstitutename">Retention Period(in Days)</mat-label>
            <input matInput [(ngModel)]="retentionPeriod" formControlName="positiveNumber" type="number" placeholder="Enter Retention Period" />
            <mat-error *ngIf="FormValid.get('positiveNumber')?.invalid && (FormValid.get('positiveNumber')?.dirty || FormValid.get('positiveNumber')?.touched)">
              <span *ngIf="FormValid.get('positiveNumber')?.hasError('required')">Retention Period is required</span>
              <span *ngIf="FormValid.get('positiveNumber')?.hasError('pattern')">
                Negative or zero values are not allowed
              </span>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <!-- Ag-Grid Section -->
  <div style="height: 1vh ">
    <div style="overflow-x: auto; overflow-y: auto; max-height: 50vh;">
      <div style="margin-top: 1%; width: 100%; ">
        <mat-toolbar class="agGridtopersDiv card" style="background: rgb(228 227 230 / 41%); border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">
          <label i18n="@@spmsUserReg" class="gridLabel">Purge Tables list</label>
          <span class="example-spacer"></span>
          
          <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                  [style.background-color]="backgroundColorButton" title="Download" (click)="onBtExport()">
            Download
            <em style="padding: 0px 0px 0px 10px" class="fas fa-download example-icon" title="Download"></em>
          </button>

          <div class="insertPageNoDiv">
            <mat-form-field appearance="outline">
              <mat-label i18n="@@Targetpageno">Page No</mat-label>
              <input matInput type="text" (input)="onSearchChange($event.target.value)" />
            </mat-form-field>
          </div>

          <!-- Records Selection -->
          <div class="selectRecordsDiv" style="width: 9.5%">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label i18n="@@Targetrecords" style="color: black">Records</mat-label>
              <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged()">
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Pagination Controls -->
          <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
          </div>

          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon">
                <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
              </li>
              <li>{{ currentPage }}/{{ totalPages }}</li>
              <li class="paginationliicon" style="padding: 0">
                <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
              </li>
            </ul>
          </div>

          <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
          </div>
        </mat-toolbar>
      </div>

      <!-- Ag-Grid Table -->
      <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin"
                       style="height: 45vh; overflow: auto;"
                       [columnDefs]="columnDefs"
                       [animateRows]="true"
                       [pagination]="true"
                       [rowSelection]="rowSelection"
                       [defaultColDef]="defaultColDef"
                       [suppressPaginationPanel]="true"
                       [rowHeight]="35"
                       [gridOptions]="gridOptions"
                       [headerHeight]="35"
                       [enableBrowserTooltips]="true"
                       [floatingFiltersHeight]="45"
                       [paginationPageSize]="paginationPageSize"
                       [paginationNumberFormatter]="paginationNumberFormatter"
                       [enableRangeSelection]="true"
                       [components]="components"
                       [debug]="true"
                       [rowClassRules]="rowClassRules"
                       [rowData]="rowData"
                       (paginationChanged)="onPaginationChangedReturn()"
                       (gridReady)="onGridReady($event)"
                       [hidden]="!true">
      </ag-grid-angular>
    </div>
  </div>

  <!-- Footer Section -->
 
</div>
<div class="row mb-1 topRowMargins" style="position: sticky; left: 0; bottom: 0; width: 100%; ">
  <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%">
    <div class="col-lg text-center">
      <div style="text-align: end;">
        <button i18n="@@TargetClear" type="button" (click)="updateData()"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                [style.background-color]="backgroundColorButton"
                style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px; color: white;">
          {{btnName}}
        </button>
        <button i18n="@@TargetCancel" type="button" (click)="close()"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
               
                style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px;background-color: white; color: black;">
          Cancel
        </button>
      </div>
    </div>
  </div>
</div>
